"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarBrandFilter = /** @class */ (function (_super) {
    __extends(ToolBarBrandFilter, _super);
    function ToolBarBrandFilter(props) {
        return _super.call(this, props) || this;
    }
    ToolBarBrandFilter.prototype.onSelectValue = function (value, option) {
        //console.log(`Selected -> ${JSON.stringify(value)}`);
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(this.props.allBrands, parseInt(value.key), "add");
        }
    };
    ToolBarBrandFilter.prototype.onDeSelectValue = function (value, option) {
        //console.log(`DeSelected -> ${JSON.stringify(value)}`);
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(this.props.allBrands, parseInt(value.key), "remove");
        }
    };
    ToolBarBrandFilter.prototype.onCheckBoxChecked = function (checked) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(checked, 0, "checkbox");
        }
    };
    ToolBarBrandFilter.prototype.getSelectItems = function () {
        var _ret = [];
        //console.log(`total brands -> ${this.props.avail_brands.length}`);
        for (var i = 0; i < this.props.availBrands.length; i++) {
            //console.log(`key  -> ${this.props.avail_brands[i].key} val -> ${this.props.avail_brands[i].value}`);
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availBrands[i].key }, this.props.availBrands[i].value));
        }
        return _ret;
    };
    ToolBarBrandFilter.prototype.getSelectedValues = function () {
        var _ret = [];
        for (var j = 0; j < this.props.selectedBrands.length; j++) {
            for (var i = 0; i < this.props.availBrands.length; i++) {
                if (this.props.availBrands[i].key === this.props.selectedBrands[j]) {
                    _ret.push({
                        key: this.props.availBrands[i].key.toString(),
                        label: this.props.availBrands[i].value
                    });
                    break;
                }
            }
        }
        return _ret;
    };
    ToolBarBrandFilter.prototype.render = function () {
        return (React.createElement("div", { style: { display: "flex", width: "100%", flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
            React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, this.props.captions.checkbox),
            React.createElement(antd_1.Switch, { checked: this.props.allBrands, onChange: this.onCheckBoxChecked.bind(this) }),
            React.createElement(antd_1.Select, { mode: "tags", style: { width: '100%', marginLeft: "5px" }, placeholder: this.props.captions.placeholder, value: this.getSelectedValues(), labelInValue: true, onDeselect: this.onDeSelectValue.bind(this), onSelect: this.onSelectValue.bind(this), disabled: this.props.allBrands }, this.getSelectItems())));
    };
    return ToolBarBrandFilter;
}(React.Component));
exports.default = ToolBarBrandFilter;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarBrandFilter.tsx
// module id = 34
// module chunks = 0